"use client";

import {
  type BottomNavigationBarProps,
  BottomNavigationBar as LayoutBottomNavigationBar,
} from "@workspace/layout-ui/src/components/BottomNavigationBar";
import isGamePageRoute from "@workspace/layout-ui/src/components/Header/isGamePageRoute";
import { useSelectedLayoutSegments } from "next/navigation";
import type { FC } from "react";

const BottomNavigationBar: FC<BottomNavigationBarProps> = (props) => {
  const segments = useSelectedLayoutSegments();

  return (
    <LayoutBottomNavigationBar
      {...props}
      initialToggleState={!isGamePageRoute(segments)}
    />
  );
};

export default BottomNavigationBar;
